/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * This represents the different types of Status for a Permission Request (PENDING\/REJECTED\/ACCEPTED)
 **/
export var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["REJECTED"] = "REJECTED";
    Status["ACCEPTED"] = "ACCEPTED";
})(Status || (Status = {}));
